
import {
  Vue, Component,
} from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
// import firebase from 'firebase';

@Component
export default class Login extends Vue {
  username = ''
  password = ''
  submitting = false
  valid = false
  alert = false
  error = ''

  created() {
    console.log('Login: created()'); // eslint-disable-line no-console

    // Logout se l'utente è già loggato
    if (this.user) {
      console.log('Login: created() utente già autenticato, effetto il logout'); // eslint-disable-line no-console

      this.$store.dispatch('logout')
        .then(() => {
          console.log('Login: created() logout riuscito'); // eslint-disable-line no-console
        })
        .catch(() => {
          console.log('Login: created() logout fallito'); // eslint-disable-line no-console
        });
    }
  }

  get user() {
    return this.$store.getters.currentUser;
  }

  get logo() {
    return this.$store.getters.logo;
  }

  get title() {
    return this.$store.getters.title;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  login() {
    console.log('Login: login()'); // eslint-disable-line no-console

    if (this.form.validate()) {
      this.submitting = true;

      // return firebase.auth().signInWithEmailAndPassword(this.email, this.password)
      return this.$store.dispatch('login', { username: this.username, password: this.password })
        .then(() => {
          console.log('Login: login() login riuscito'); // eslint-disable-line no-console

          // // Recupero l'utente
          // this.$store.getters['auth/user']();

          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect as RawLocation);
          } else {
            this.$router.replace('/');
          }
        })
        .catch((error) => {
          console.log('Login: login() login fallito'); // eslint-disable-line no-console
          console.log(error); // eslint-disable-line no-console

          const { data } = error?.response;

          this.submitting = false;

          switch (data?.code) {
            case 'auth/invalid-email':
              this.error = 'L\'indirizzo email non è nel formato corretto';
              break;

            case 'auth/user-not-found':
              this.error = 'Non esiste un utente con questo indirizzo email';
              break;

            case 'auth/wrong-password':
              this.error = 'La password non è corretta';
              break;

            // L'utente non ha i permessi per accedere
            case 'auth/permission-denied':
              this.error = 'Non hai i permessi per accedere';
              break;

            default:
              this.error = `Errore sconosciuto (${data?.code})`;
              break;
          }

          this.alert = true;
        });
    }

    return false;
  }
}
